<template>
  <v-app light>
    <v-toolbar app class="decide-background-color-a">
      <v-toolbar-title class="headline text-uppercase">
        <!-- <span>Statable </span> -->
        <!-- <span class="font-weight-light">Lao DECIDE info</span> -->
        <div slot="media"> 
            <a href="https://www.k4d.la/">               
            <img :src="getHeaderLogo" height="56px" style="margin-top: 5px">
            </a>
        </div>
      </v-toolbar-title>     
      <v-spacer></v-spacer>
      <v-btn   
        depressed
        color="#346cb6 "
        class="ma-0 white--text"
        @click="lngBtnClick"
      >
      <template>
        <gb-flag
            :code="getLngIconText"
            size="small"
            class="ma-2"
        /> 
        </template>                               
        {{ $t('lngBtnText') }}                
      </v-btn>       
    <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="#346cb6" class="ma-0 white--text" depressed v-on="on">
            <v-icon white>fas fa-bars</v-icon>
          </v-btn>
        </template>
        <v-list id="nav-dropdown-content">
          <v-list-tile class="nav-btn-icon"
            v-for="(item, index) in items"
            :key="index"
            @click=""
            :href="getItemLink(index)" :target="getLinkTargetOption(index)"
          >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <MainContent/>
    </v-content>

    <v-footer
      color="grey lighten-4"
      app
    >
      <v-card-text class="align-center">
        © {{ new Date().getFullYear() }} <strong><a href="https://www.k4d.la/">K4D</a></strong>
      </v-card-text>
    </v-footer>
  </v-app>
</template>

<script>
import MainContent from './components/MainContent'

export default {
  name: 'App',
  components: {
    MainContent
  },
  data () {
    return {
      items: [
        { title: this.$t('navMenu.home') },
        { title: this.$t('navMenu.mapExplorer') },
        { title: this.$t('navMenu.mapAnalyst') },
        { title: this.$t('navMenu.oda') },
        { title: this.$t('navMenu.mapRepository') },
        { title: this.$t('navMenu.catalogue') },
        { title: this.$t('navMenu.publication') },
        { title: this.$t('navMenu.help') }
      ],
      icons: [
        'fab fa-facebook',
        'fab fa-linkedin',
        'fab fa-youtube'
      ],
      flag: 'la'
    }
  },
  computed: {
    getLngIconText() {
      if (this.$i18n.locale === 'en') return 'la';
      else return 'gb';
    },
    getHeaderLogo() {
      if (this.$i18n.locale === 'en') return './logos/K4D_Dev_Indicators.svg';
      else return './logos/K4D_Dev_Indicators_Lao.svg';
    }
  },
  methods: {
    lngBtnClick(){
      if (this.$i18n.locale === 'en') {
        this.$router.push('/lo');
        this.$router.go();
      }
      else {
        this.$router.push('/en');
        this.$router.go();
      }
    },
    getItemLink(index){
      if (this.$i18n.locale === 'en') {
        switch(index){
          case 0:
            return 'https://www.k4d.la/';
          case 1:
            return 'https://apps.k4d.la/explorer/';
          case 2:
            return 'https://apps.k4d.la/analyst/';
          case 3:
            return 'https://apps.k4d.la/oda/';
          case 4:
            return 'https://www.k4d.la/maprepository/';
          case 5:
            return 'https://en.data.k4d.la/';
          case 6:
            return 'https://www.k4d.la/publications/';
          case 7:
            return 'https://www.k4d.la/wp-content/uploads/2021/11/Laos_k4d_manual_en.pdf';
        }
      }
      else {
        switch(index){
          case 0:
            return 'https://www.k4d.la/lo/home-%e0%ba%a5%e0%ba%b2%e0%ba%a7/';
          case 1:
            return 'https://apps.k4d.la/explorer/?config=config_lo.json&locale=lo';
          case 2:
            return 'https://apps.k4d.la/analyst/?config=config_lo.json&locale=lo';
          case 3:
            return 'https://apps.k4d.la/oda/?config=config_lo.json&locale=lo';
          case 4:
            return 'https://www.k4d.la/lo/maprepository-lo/';
          case 5:
            return 'https://lo.data.k4d.la/';
          case 6:
            return 'https://www.k4d.la/lo/publications-lo/';
          case 7:
            return 'https://www.k4d.la/wp-content/uploads/2021/11/Laos_k4d_manual_lo.pdf';
        }
      }
    },
    getLinkTargetOption(index) {
      if (index == 7) return "_blank";
      else return "_self";
    }
  }
}
</script>

<style>
  /* fontawesome styles */
  @import url('https://use.fontawesome.com/releases/v5.6.3/css/all.css');
  /* html, body {
    overflow: hidden
  } */
  .decide-background-color-a {
    background-color: #346cb6  !important;
  }
  .align-center {
    text-align: center;
  }
  /* set min-width for all buttons */
  .v-btn {
    min-width: auto;
  }
  /* set list item's line height and font size */
  .v-list__tile {
    max-height: 28px;
    font-size: 14px;
  }
  /* change styling of menu links to match other applications */
    .nav-btn-icon {
      border-style: solid;
        border-color: #efefef;
        border-width: 0 0.5px 0.5px 0.5px;
        padding: 0px 10px 0px 10px;
        background-color: white;
        min-width: 200px;
        height: 40px;
    }

    .nav-btn-icon > a{
        max-height: 40px;
    }
    .nav-btn-icon > a:hover{
        background: transparent !important;
    }

    #nav-dropdown-content{
        box-shadow: 0px 2px 15px 0px rgb(0 0 0 / 10%);
    }

    #nav-dropdown-content{
        padding:0px;
    }
    .nav-btn-icon .v-list__tile__title{
        text-align: center;
        color: #3D4459;
        font-size: 13px;
        font-family: Verdana, Geneva, sans-serif;
        font-weight: 400;
    }
    .nav-btn-icon:hover .v-list__tile__title{
        color: #5A33E9;
    }
</style>
